// @ts-strict-ignore
import * as React from 'react';

import { Playlist } from 'api';

import getImageFromSet from 'lib/get-image-from-set';

import Grid from 'components/grid';
import Col from 'components/grid/col';
import PlaylistCard from 'components/playlist-card';
import { LazyLoadAd, PlaylistAds } from '../../../ads';

type FeaturedPlaylistsProps = {
  playlists: Playlist[];
};

function FeaturedPlaylists({
  playlists
}: FeaturedPlaylistsProps): React.ReactNode {
  return (
    <section id="featured-playlists">
      <Grid>
        {playlists.map(playlist => {
          const imageUrl = getImageFromSet(playlist.primaryImageSet, '1x1');

          return (
            <Col sm={4} md={3} lg={3} key={playlist.title}>
              <PlaylistCard
                priority
                size="l"
                className="mb-8"
                href={`/playlists/${playlist.id}/${playlist.slug}`}
                imageUrl={imageUrl}
                title={playlist.title}
                description={playlist.description}
                author={playlist.author !== 'TED' && playlist.author}
                talksCount={playlist.videos.totalCount}
              />
            </Col>
          );
        })}
        {playlists.length < 4 && (
          <Col sm={4} md={3} lg={3}>
            <LazyLoadAd>
              <PlaylistAds.PlaylistIndexAdInlineATF />
            </LazyLoadAd>
          </Col>
        )}
      </Grid>
    </section>
  );
}

export default FeaturedPlaylists;
